import $ from 'jquery';
import ScrollSpy from 'bootstrap/js/src/scrollspy';
import {lazyInitByScroll} from '../helpers/lazyInit';
import {loadArrangementListMainContent} from '../helpers/arrangementListPageHelpers';
import GalleryWithPreview from './GalleryWithPreview';

class RichContentPageContent {
	constructor(params) {
		this.params = params;
		
		this.init();
	}
	
	init() {
		new GalleryWithPreview();
		this.initEvents();
		
		requestAnimationFrame(() => {
			this.initArrangementsList();
			lazyInitByScroll(this.initScrollspy.bind(this));
		});
	}
	
	initScrollspy() {
		const self = this;
		
		if ($('#nav-indicatorMarkers').length) {
			new ScrollSpy(
				document.body,
				{
					'target': '#nav-indicatorMarkers',
					'offset': 300
				}
			);
			
			$('#nav-indicatorMarkers').on('click', 'a', function(ev) {
				self.scrollToTarget($($(this).attr('href')));
				ev.preventDefault();
			});
		}
	}
	
	/**
	 * @param {jQuery} obj
	 */
	scrollToTarget(obj) {
		if (!obj || !obj.length) {
			return;
		}
		
		const body = $('html, body');
		
		body.stop().animate(
			{
				'scrollTop': obj.offset().top - 150
			},
			500,
			'swing'
		);
	}
	
	initArrangementsList() {
		if ($('#arrangementsList').length) {
			loadArrangementListMainContent({
				'beforeFilteringRequest': (filterQuery) => {
					filterQuery.shouldShowRedesignedClubPage = true;
				}
			});
		}
	}
	
	initEvents() {
		$(window).on('scroll', () => {
			requestAnimationFrame(() => {
				this.setSticky();
			});
		});
	}
	
	setSticky() {
		const {scrollTop} = document.documentElement,
		      headerHeight = parseInt($('header').height()),
		      subNav 	   = $('.sub-nav');
		
		if (scrollTop > headerHeight) {
			subNav.addClass('sticky');
		} else if (scrollTop < headerHeight) {
			subNav.removeClass('sticky');
		}
	}
	
}

export default RichContentPageContent;